



















import {
    State,
    Action,
    Getter,
    Mutation
} from "vuex-class";
import {
    Component,
    Vue,
    Prop,
    Watch
} from "vue-property-decorator";
import {
    componentDataType
} from "../types";
import {
    pageDataType
} from "../types";
import {
    HOST
} from "../global";

@Component({
    name: "VideoCard",

})
export default class VideoCard extends Vue {
    @Prop() public compData!: string | null;
    public HOST: string = HOST;
    public data() {
        let videoId = (this as any).compData.video_id;
        return {
            videoId: videoId,
            host: 'https://www.youtube.com'
        }
    }
    playVideo() {
        (this as any).$refs.youtube.player.playVideo()

        // const vdpost =
        //     (this.$refs.vdposter as HTMLElement) ||
        //     document.querySelector(".vdposter");
        // vdpost.style.display = 'none';
        const playbtn =
            (this.$refs.plybtn as HTMLElement) ||
            document.querySelector("#play-video");
        playbtn.style.display = 'none';
    }
    // playing() {
    //     console.log('\o/ we are watching!!!')
    // }

    player() {
        return (this as any).$refs.youtube.player
    }

    // player() {
    //     return (this as any).$refs.videoPlayer.player
    // }

    // public mounted() {

    // }
}
